export type LabelingCategoryKey =
  | "3d-segmentation"
  | "segmentation-studies"
  | "reporter-studies"
  | "triage-validation"
  | "other";

export interface LabelingCategory {
  key: LabelingCategoryKey;
  name: string;
  mono: string;
  description: string;
}

export const CATEGORIES: LabelingCategory[] = [
  {
    key: "3d-segmentation",
    name: "3D Segmentation Annotations",
    mono: "seg",
    description: "Volumetric organ & lesion masks on CT.",
  },
  {
    key: "segmentation-studies",
    name: "Segmentation Studies",
    mono: "study",
    description: "Timed model-seeded and blank 3D segmentation comparisons.",
  },
  {
    key: "reporter-studies",
    name: "Reporter Studies",
    mono: "report",
    description: "Dictate structured reports from AI or blank templates.",
  },
  {
    key: "triage-validation",
    name: "Triage Validation",
    mono: "triage",
    description: "Read & confirm AI triage findings on abdominopelvic CT.",
  },
  {
    key: "other",
    name: "Other",
    mono: "other",
    description: "Everything not in the buckets above.",
  },
];

export function categoryForProjectType(pt?: string): LabelingCategoryKey {
  if (pt === "segmentation" || pt === "both" || pt === "cohort_segmentation")
    return "3d-segmentation";
  if (pt === "segmentation_study" || pt === "joint_review") return "segmentation-studies";
  if (pt === "reporting") return "reporter-studies";
  if (pt === "classification" || pt == null) return "triage-validation";
  return "other";
}

export function bucketProjects<T extends { project_id: string; project_type?: string }>(
  projects: T[],
): Record<LabelingCategoryKey, T[]> {
  const out = {
    "3d-segmentation": [],
    "segmentation-studies": [],
    "reporter-studies": [],
    "triage-validation": [],
    other: [],
  } as Record<LabelingCategoryKey, T[]>;
  for (const p of projects) out[categoryForProjectType(p.project_type)].push(p);
  return out;
}
